<div class="contractors-wrapper">
  <app-contractor-list></app-contractor-list>
</div>